
export default {
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      promocode: null
    }
  },
  methods: {
    async applyPromocode() {
      try {
        this.loading = true
        await this.$axios.post(`/api/pricezone/${this.id}/unlock`, {
          promocode: this.promocode
        })
        this.$emit('promo-checked')
        this.$notify({
          type: 'success',
          group: 'ts',
          title: this.$t('headings.success'),
          text: this.$t('text.promocode_activated')
        })
      } catch (e) {
        this.loading = false
      }
    }
  }
}
